import { Button, VARIANTS } from 'shared';
import { Icon, iconNames } from 'shared_DEPRECATED/components/Icon';

import { useAddGoal } from 'features/goal';

export const GoalAddButton = () => {
  const { onAddGoalClick } = useAddGoal();

  return (
    <Button
      onClick={() => onAddGoalClick()}
      color={VARIANTS.PRIMARY}
      data-testid="add-new-goal-btn"
    >
      <Icon
        width="10px"
        height="10px"
        name={iconNames.plus}
        stroke="var(--fgPrimaryInverse)"
      />{' '}
      Add goal
    </Button>
  );
};
